import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table, Pagination } from 'antd';
import { CloseCircleOutlined, UserOutlined, FolderOpenOutlined, SkinOutlined, StarOutlined, TagOutlined, SkinFilled } from '@ant-design/icons';
import { isEqual } from 'lodash';
import { JobSubdivideEnum } from '../components/SelectPosition';

class ResultTable extends PureComponent {
	static propTypes = {
		selectType: PropTypes.string,
		selectChild: PropTypes.bool,
		selects: PropTypes.array,
		removeItems: PropTypes.func.isRequired,
		clearAll: PropTypes.func.isRequired,
	}

	constructor (props) {
		super(props);
		this.state = {
			resultPage: 0,
			selects: this.getDisabledList(props).selects,
			mustSelects: this.getDisabledList(props).mustSelects,
		};
	}

	componentWillReceiveProps (nextProps) {
		const { props } = this;
		let { resultPage } = this.state;
		const originResultPage = resultPage;
		const len = props.selects.length;
		let newLen = nextProps.selects.length;
		const count = newLen - len;
		if (!isEqual(props.selects, nextProps.selects)) {
			const selects = this.getDisabledList(nextProps).selects;
			const mustSelects = this.getDisabledList(nextProps).mustSelects;
			this.setState({ selects, mustSelects });
			newLen = selects.length;
		}
		if (newLen === 0) { // 清空了数据
			resultPage = 0;
		} else if (count === 1) { // 单条增加
			if (newLen % 100 === 0) {
				resultPage = Math.floor(newLen / 100) - 1;
			} else {
				resultPage = Math.floor(newLen / 100);
			}
		} else if (count > 1) { // 批量增加
			if (len === 0) {
				resultPage = 0;
			} else {
				resultPage = Math.floor(len / 100);
			}
		} else if (count <= -1) {  // 减少
			if (newLen % 100 === 0) {
				resultPage = Math.floor(newLen / 100) - 1;
			} else {
				resultPage = Math.floor(newLen / 100);
			}
			if (originResultPage <= resultPage) {
				resultPage = originResultPage;
			}
		}
		this.setState({ resultPage });
	}

	//将selects封装成包含是否可选择参数的列表
	getDisabledList = (props) => {
		const { selects = [], disabledSelects = [], isSingleTab } = props;
		const mustSelects = [];
		let newSelects = [];
		if (disabledSelects.length < 0) {
			// newSelects = selects.reduce((pre, cur) => {
			// 	if (!pre.some(val => {
			// 		//非组合选的是时候 只需判定sourceIdA
			// 		if (isSingleTab) {
			// 			return 	val.sourceIdA === cur.sourceIdA;
			// 		}
			// 		return val.flowUserSelectionType === cur.flowUserSelectionType &&
			//             Number(val.sourceIdA) === Number(cur.sourceIdA) &&
			//             val.sourceTypeB === cur.sourceTypeB;
			// 	})) {
			// 		pre.push(cur);
			// 	}
			// 	return pre;
			// }, []);
			return;
		}
		newSelects = selects.map(val => {
			if (disabledSelects.some(obj => {
				if (isSingleTab) {
					return Number(obj.sourceIdA) === Number(val.sourceIdA);
				}
				return Number(obj.sourceIdA) === Number(val.sourceIdA) && (obj.flowUserSelectionType === val.flowUserSelectionType) &&
					val.sourceTypeB === obj.sourceTypeB;
			})) {
				mustSelects.push(val);
				return { ...val, isDisabled: true };
			}
			return { ...val, isDisabled: false };
		});

		// 数据去重
		const newSelects_ = [];
		const ids = [];
		newSelects.map((item, index) => {
			const { sourceIdA, sourceIdB } = item;
			const pos = ids.indexOf(`${sourceIdA}-${sourceIdB}`);
			if (pos === -1) {
				newSelects_.push(item);
				ids.push(`${sourceIdA}-${sourceIdB}`);
			}
		});

		return { selects: newSelects_, mustSelects };
	}

	// 生成结果表格列
	getResultColumns = () => {
		const { removeItems } = this.props;
		return [{
			title: '名称',
			dataIndex: 'selectionName',
			align: 'left',
			render: (value, row) => {
				// const iconType = this.getType(row);
				return (
					<div className={`column-item ${row.isDisabled ? 'disabled-item' : ''}`}>
						{this.getType(row)}
						{/* {!!iconType && <Icon type={iconType} theme='outlined' className='type-icon' />} */}
						<span className='column-name' title={value}>{value}</span>
						<CloseCircleOutlined className={row.isDisabled ? 'close-icon disabled-click' : 'close-icon'} disabled={row.isDisabled}
							onClick={() => { !row.isDisabled && removeItems([row]); }} />
					</div>
				);
			}
		}];
	}

	getType = ({ sourceTypeA, flowUserSelectionType, sourceDataA }) => {
		switch (sourceTypeA) {
			case 'source_business_department': return <UserOutlined className='type-icon'/>;
			case 'source_user': return <UserOutlined className='type-icon' />;
			case 'source_department':
				if (flowUserSelectionType === 'manager') return <UserOutlined className='type-icon' />;
				return <FolderOpenOutlined className='type-icon' />;
			case 'source_position':
				if (sourceDataA?.jobSubdivide === JobSubdivideEnum.SPACE) return <SkinFilled className='type-icon' />;
				return <SkinOutlined className='type-icon' />;
			case 'source_level': return <StarOutlined className='type-icon' />;
			case 'source_label': return <TagOutlined className='type-icon' />;
			case 'source_variable': return <UserOutlined className='type-icon' />;
			default: return <FolderOpenOutlined className='type-icon' />;
		}
	}

	// 生成结果列表组件
	renderResultTable = () => {
		const { state } = this;
		const { resultPage, selects = [] } = state;
		const start = resultPage * 100;
		const dataSource = selects.slice(start, start + 100);
		if (selects.length > 0) {
			return <Table
				columns={this.getResultColumns()}
				dataSource={dataSource}
				size='small'
				pagination={false}
				className='result-table'
				showHeader={false}
			/>;
		}
		return (<div className='result-table' />);
	}

	onPageSizeChange = (page) => {
		this.setState({ resultPage: page - 1 });
	}

	render () {
		const { clearAll, showName } = this.props;
		const { resultPage, selects = [], mustSelects = [] } = this.state;
		return <div className='result-box-wrapper'>
			<p className='lineh22 text-right clearfix'>
				{showName && <span className='pull-left'>已选{selects.length > 0 && `（${selects.length}）`}</span>}
				{<span className={selects.length > 0 && selects.length !== mustSelects.length ? 'link-text' : 'disabled-click'} onClick={() => clearAll(mustSelects)}>清除全部</span>}
			</p>
			{this.renderResultTable()}
			{Math.ceil(selects.length / 100) > 1
				? <Pagination
					simple
					pageSize={100}
					current={resultPage + 1}
					total={selects.length}
					onChange={this.onPageSizeChange}
				/> : null
			}

		</div>;
	}
}

export default ResultTable;
